import { ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { KeyValues5, LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-usage-limits',
  templateUrl: './usage-limits.component.html',
  styleUrls: ['./usage-limits.component.scss']
})
export class UsageLimitsComponent implements OnInit {
  @Input() items: KeyValues5[];
  @Output() itemsChange = new EventEmitter<any>();
  maxBodyHeight = 0;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

}
